module.exports = __webpack_public_path__ + "img/firstimg.d44947c4.svg";